import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { COLUMNS_HEADER_PRODUCT_MIXTION_ADMIN } from '../../core/constants/tables.constants';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { faMagnifyingGlass, faSpinner, faUpload, faDownload } from '@fortawesome/pro-solid-svg-icons';
import * as XLSX from 'xlsx';
import { ProductMixtionService } from '../../core/services/product-mixtion.service';
import { ToastrService } from 'ngx-toastr';
import { GenericTableComponent } from '../../components/generic-table/generic-table.component';
import { FileUploadComponent } from '../../components/file-upload/file-upload.component';
import { UploadApoStepsComponent } from '../../components/upload-apo-steps/upload-apo-steps.component';

@Component({
  selector: 'app-product-mixtion',
  standalone: true,
  imports: [
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    GenericTableComponent,
    FileUploadComponent,
    UploadApoStepsComponent,
  ],
  templateUrl: './product-mixtion.component.html',
  styleUrl: './product-mixtion.component.scss'
})
export class ProductMixtionComponent {
  COLUMNS_HEADER = COLUMNS_HEADER_PRODUCT_MIXTION_ADMIN;

  products: any;
  productsFiltered: any;
  blenders: any;
  productNatureTypes: any;

  isModalActive = false;
  isLoading = false;
  isCreating = false;
  isUploadModalActive = false;
  isUploading = false;
  selectedFile: any = null;
  validatedData: any = null;
  uploadSteps: any = [];
  selectedUploadStep = 'upload';

  faSpinner = faSpinner;
  faMagnifyingGlass = faMagnifyingGlass;
  faUpload = faUpload;
  faDownload = faDownload;

  form: FormGroup = this.formBuilder.group({
    grad: [, Validators.required],
    name: ['', Validators.required],
    mixtion: ['', Validators.required],
    cantidadMP: [''],

  });

  filters: any = {
    search: {
      value: '',
      filter: (obj: any): boolean => {
        return (obj.grad?.toLowerCase().includes(this.filters.search.value.toLowerCase()) || obj.name?.toLowerCase().includes(this.filters.search.value.toLowerCase()) || obj.mixtion?.toLowerCase().includes(this.filters.search.value) )
      }
    },
  };

  constructor(
    private productMixtionSvc: ProductMixtionService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.getProducts();
    this.initUploadSteps();
  }

  initUploadSteps() {
    this.uploadSteps = [
      {
        name: 'upload',
        description: '1. Cargar archivo',
        completed: false,
        active: true
      },
      {
        name: 'validate',
        description: '2. Validar registros',
        completed: false,
        active: false
      }
    ];
  }

  async onSave() {
    this.isLoading = true;
    const responseAction = {
      next: () => {
        this.getProducts();
        this.isModalActive = false;
        this.isLoading = false;
        if (this.isCreating) {
          this.toastr.success(`El producto ${this.form.value.grad} ha sido creado correctamente`);
        } else {
          this.toastr.success(`El producto ${this.form.value.grad} ha sido actualizado correctamente`);
        }
        this.form.reset();

      },
      error: () => {
        this.isLoading = false;
      }
    };

    if (this.form.valid) {
      if (this.isCreating) {
        this.productMixtionSvc.createProductMixtion(this.form.value).subscribe(responseAction);
      } else {
        this.productMixtionSvc.updateProductMixtion(this.form.value).subscribe(responseAction);
      }
    }
  }

  getProducts() {
    this.productMixtionSvc.getProductMixtions().subscribe((res: any) => {
      this.products = [...res];
      this.productsFiltered = res;
      this.onFilter();
      this.isLoading = false;
    });
  }


  openModal(item?: any) {
    if (item) {
      this.form.patchValue(item);
      this.isCreating = false;
    } else {
      this.isCreating = true;
    }
    this.isModalActive = true;
  }

  closeModal() {
    this.isModalActive = false;
    this.form.reset();
    this.isCreating = false;
  }

  delete(item?: any) {
    this.isLoading = true
    this.productMixtionSvc.deleteProductMixtion(item.grad).subscribe({
      next: () => {
        this.getProducts();
        this.isLoading = false;
        this.toastr.success(`El producto ${item.grad} ha sido eliminado correctamente`);
      },
      error: () => {
        this.isLoading = false
      }
    })
  }

  onFilter() {
    this.productsFiltered = this.products.filter((obj: any) => {
      return Object.keys(this.filters).map(f => {
        return !this.filters[f].value ? true : this.filters[f].filter(obj);
      }).filter(f => f).length === Object.keys(this.filters).length;
    });
  }

  resetFilters(keysSelected: any) {
    for (const key of Object.keys(this.filters)) {
      if (!keysSelected.includes(key)) {
          this.filters[key] = '';
      }
    }
  }

  openUploadModal() {
    this.isUploadModalActive = true;
    this.selectedFile = null;
    this.validatedData = null;
    this.selectedUploadStep = 'upload';
    this.initUploadSteps();
  }

  closeUploadModal() {
    this.isUploadModalActive = false;
    this.selectedFile = null;
    this.validatedData = null;
    this.selectedUploadStep = 'upload';
    this.initUploadSteps();
  }

  onFileSelected(file: any) {
    this.selectedFile = file;
    this.validateFile();
  }

  validateFile() {
    if (!this.selectedFile) {
      this.toastr.warning('Por favor, selecciona un archivo primero');
      return;
    }

    this.isUploading = true;
    
    this.productMixtionSvc.uploadValidateProductMixtion(this.selectedFile).subscribe({
      next: (response: any) => {
        this.validatedData = response;
        this.isUploading = false;
        this.uploadSteps[0].completed = true;
        this.uploadSteps[0].active = false;
        this.uploadSteps[1].active = true;
        this.selectedUploadStep = 'validate';
        
        if (response.warnings && response.warnings.length > 0) {
          for (let warning of response.warnings) {
            this.toastr.warning('', warning, {
              positionClass: 'toast-bottom-right',
              timeOut: 60000,
              closeButton: true,
              tapToDismiss: false,
              disableTimeOut: 'extendedTimeOut'
            });
          }
        }
      },
      error: (error) => {
        this.isUploading = false;
        this.toastr.error('Error al cargar el archivo. Por favor, verifica el formato.');
      }
    });
  }

  onSelectUploadTab(step: any) {
    if (step.name === 'validate' && !this.validatedData) {
      this.toastr.warning('Primero debes cargar un archivo');
      return;
    }
    this.uploadSteps.forEach((s: any) => s.active = false);
    step.active = true;
    this.selectedUploadStep = step.name;
  }

  confirmUpload() {
    if (!this.validatedData || !this.validatedData.processedRows) {
      this.toastr.warning('No hay datos para guardar');
      return;
    }

    this.isUploading = true;
    const payload = {
      rows: this.validatedData.processedRows.map((row: any) => ({
        grad: row.grad,
        name: row.name,
        mixtion: row.mixtion,
        cantidadMP: row.cantidadMP,
        status: row.status
      }))
    };

    this.productMixtionSvc.saveLoadProductMixtion(payload).subscribe({
      next: () => {
        this.isUploading = false;
        this.closeUploadModal();
        this.getProducts();
        this.toastr.success('Registros cargados correctamente');
      },
      error: (error) => {
        this.isUploading = false;
        this.toastr.error('Error al guardar los registros');
      }
    });
  }

  downloadExcel() {
    if (!this.productsFiltered?.length) {
      this.toastr.warning('No hay datos para exportar');
      return;
    }

    const dataToExport = this.productsFiltered.map((row: any) => ({
      'Grad': row.grad,
      'Nombre': row.name,
      'Mixtion': row.mixtion,
      '% Cantidad MP': row.cantidadMP ?? ''
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    
    // Anchos de columna
    worksheet['!cols'] = [
      { wch: 20 },  // Grad
      { wch: 45 },  // Nombre
      { wch: 15 },  // Mixtion
      { wch: 15 }   // % Cantidad MP
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Producto-Mixtion');

    const fileName = `producto-mixtion_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(workbook, fileName);
    
    this.toastr.success('Archivo descargado correctamente');
  }
}
